import api from "../api/axios";

export const getPolicyType = async (companyId) => {
  try {
    const response = await api.get(`hr/policy-types?companyId=${companyId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching policy types:", error);
    throw error;
  }
};
export const savePolicyData = async (data) => {
  try {
    const response = await api.post("hr/upload-policy", data);
    return response.data;
  } catch (error) {
    console.error("Error saving policy data:", error);
    throw error;
  }
};

export const updatePolicyVersion = async (policyId, data) => {
  try {
    const response = await api.put(
      `hr/update-policy-version/${policyId}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating policy version:", error);
    throw error;
  }
};

export const getEmployeePolicies = async (employeeId) => {
  try {
    const response = await api.get(`hr/employee/${employeeId}/policies`);
    return response.data;
  } catch (error) {
    console.error("Error fetching employee policies:", error);
    throw error;
  }
};

export const acknowledgePolicy = async (data) => {
  try {
    const response = await api.post("hr/acknowledge-policy", data);
    return response.data;
  } catch (error) {
    console.error("Error acknowledging policy:", error);
    throw error;
  }
};

export const getPolicyAcknowledgementStatus = async (
  policyId,
  policyVersion
) => {
  try {
    const response = await api.get(
      `hr/policy-acknowledgement-status/${policyId}/${policyVersion}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching policy acknowledgement status:", error);
    throw error;
  }
};

export const checkAllPoliciesAcknowledged = async (employeeId) => {
  try {
    const response = await getEmployeePolicies(employeeId);
    const policies = response?.results || [];
    
    if (policies.length === 0) {
      // If no policies exist, consider them all acknowledged
      return { allAcknowledged: true, unacknowledgedPolicies: [] };
    }
    
    const unacknowledgedPolicies = policies.filter(
      (policy) => policy.acknowledgment_status !== "ACKNOWLEDGED"
    );
    
    return {
      allAcknowledged: unacknowledgedPolicies.length === 0,
      unacknowledgedPolicies: unacknowledgedPolicies,
      totalPolicies: policies.length,
      acknowledgedCount: policies.length - unacknowledgedPolicies.length
    };
  } catch (error) {
    console.error("Error checking policy acknowledgment status:", error);
    throw error;
  }
};
